export function formatEndsOn(ts: any): string | null {
  const seconds = ts?.seconds;
  if (!seconds) return null;
  try {
    return new Date(Number(seconds) * 1000).toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return null;
  }
}
